// src/store/store.js
import { configureStore } from "@reduxjs/toolkit";
import chatbotReducer from "./chatbotSlice";

export const store = configureStore({
  reducer: {
    chatbots: chatbotReducer,
  },
});
